/** La mappa delle aziende nella console e nel link condiviso (27/10/2026). Gemello di `en.ts`. */
export default {
  pagina: {
    titolo: 'Mappa delle aziende',
    titolo_condivisa: 'Le aziende che lavorano con YumaOS',
    descrizione: 'Dove sono le aziende che usano YumaOS, con i loro account e le persone che ci lavorano.',
    elenco: 'Elenco',
    mappa: 'Mappa',
    vista: 'Come vedere le aziende',
    condividi: 'Condividi la mappa',
    aggiorna: 'Aggiorna i dati',
    caricamento: 'Disegno la mappa…',
    errore: 'La mappa non si è caricata: {{motivo}}',
    riprova: 'Riprova',
    aggiornata: 'Dati del {{quando}}',
    fonte_confini: 'Confini: ISTAT, elaborazione openpolis (CC BY 4.0)',
    confini_assenti: 'Il disegno dell’Italia non si è caricato: le aziende sono al loro posto, ma senza i confini.',
    valida_fino: 'Link valido fino al {{data}}',
  },
  livelli: {
    free: 'Free',
    base: 'Base',
    pro: 'Pro',
    business: 'Business',
  },
  stati: {
    attiva: 'Attive',
    pagamenti_in_ritardo: 'Pagamenti in ritardo',
    sospesa: 'Sospese',
    bloccata: 'Bloccate',
    cancellata: 'Cancellate',
  },
  stato_singolare: {
    attiva: 'Attiva',
    pagamenti_in_ritardo: 'Pagamenti in ritardo',
    sospesa: 'Sospesa',
    bloccata: 'Accesso bloccato',
    cancellata: 'Cancellata',
  },
  filtri: {
    adesso: 'Al lavoro adesso',
    adesso_gruppo: 'In questo momento',
    stato: 'Quali aziende',
    livello: 'Livelli',
    tutte: 'Tutte',
    nessuna: 'Nessuna azienda con questi filtri.',
    mostra_tutte: 'Mostra tutte le aziende',
  },
  riepilogo: {
    come_sedi: 'Il cerchietto tratteggiato: un’altra sede della stessa azienda.',
    come_archi: 'Gli archi partono dall\'azienda di un partner e arrivano alle aziende che ha portato su YumaOS.',
    sedi_one: '{{count}} sede',
    sedi_other: '{{count}} sedi',
    adesso_one: 'persona al lavoro adesso',
    adesso_other: 'persone al lavoro adesso',
    adesso_breve: 'adesso',
    come_polso: 'Il cerchio verde che pulsa: qualcuno ci sta lavorando adesso (ha fatto qualcosa nel gestionale negli ultimi {{minuti}} minuti, o ha l’app aperta davanti). Una pagina aperta e ferma non conta.',
    numero_adesso: '{{adesso}} adesso',
    aziende_one: 'azienda',
    aziende_other: 'aziende',
    account_one: 'account',
    account_other: 'account',
    persone_one: 'persona al lavoro negli ultimi {{giorni}} giorni',
    persone_other: 'persone al lavoro negli ultimi {{giorni}} giorni',
    account_per_livello: 'Gli account per livello',
    livello_conto: '{{livello}} {{numero}}',
    come_si_legge: 'Come si legge',
    come_alone: 'L’alone è grande quanto gli account dell’azienda.',
    come_nucleo: 'Al centro il logo; il colore attorno è grande quanto le persone che hanno usato il sistema negli ultimi {{giorni}} giorni.',
    come_colore: 'Il colore è il livello: Free è il solo contorno.',
    elenco: 'Le aziende',
    al_lavoro_breve: 'al lavoro',
    al_lavoro: '{{attive}} al lavoro',
    senza_posizione: 'Non sulla mappa',
    motivi: {
      senza_indirizzo: 'manca l’indirizzo della sede',
      indirizzo_non_trovato: 'l’indirizzo della sede non si trova',
      fuori_dall_italia: 'la sede è fuori dall’Italia',
      posizione_non_calcolata: 'posizione non calcolata, riprova più tardi',
    },
  },
  scheda: {
    portata_da: 'Portata su YumaOS da',
    ha_portato: 'Ha portato su YumaOS',
    fornitore: 'Fornitore di materiale',
    rifornisce: 'Rifornisce',
    rifornisce_quante_one: '{{count}} azienda',
    rifornisce_quante_other: '{{count}} aziende',
    fuori_dai_filtri: 'non in vista coi filtri di adesso',
    chi_lavora_adesso: 'Chi sta lavorando adesso',
    canale: {
      gestionale: 'Gestionale',
      app: 'App',
    },
    canale_aiuto: {
      gestionale: 'Sta usando il gestionale, nel browser del computer o del tablet',
      app: 'Sta usando un’app Android (YumaCALL o YumaWORK)',
    },
    sedi: 'Sedi',
    sede_principale: 'principale',
    sede_legale: 'sede legale: l’azienda non ha scritto sedi operative',
    al_centro_del_comune: 'al centro del comune: la via non si è trovata',
    vai_alla_sede: 'Mostra {{sede}} sulla mappa',
    sedi_fuori_one: '{{count}} sede operativa non è sulla mappa: {{motivo}}',
    sedi_fuori_other: '{{count}} sedi operative non sono sulla mappa: {{motivo}}',
    adesso: 'Al lavoro adesso',
    adesso_valore_one: '{{count}} persona',
    adesso_valore_other: '{{count}} persone',
    pagina_aperta: 'Pagina aperta, ma ferma',
    chi_ha_la_pagina_aperta: 'Chi ha il gestionale aperto ma non lo sta usando',
    ultima_azione: 'ultima azione {{quando}}',
    ultima_azione_non_misurata: 'ultima azione non ancora misurata (il suo gestionale va ricaricato)',
    adesso_nessuno: 'nessuno in questo momento',
    torna: 'Torna al riepilogo',
    logo: 'Logo di {{nome}}',
    iscritta: 'Iscritta il',
    account: 'Account',
    account_totale_one: '{{count}} account',
    account_totale_other: '{{count}} account',
    nessun_account: 'Nessun account',
    persone_attive: 'Al lavoro negli ultimi {{giorni}} giorni',
    attive_su: '{{attive}} su {{totale}}',
    ultimo_uso: 'Ultimo utilizzo',
    ultimo_uso_oggi: 'oggi alle {{ora}}',
    ultimo_uso_ieri: 'ieri alle {{ora}}',
    ultimo_uso_settimana: '{{giorno}} alle {{ora}}',
    ultimo_uso_prima: '{{data}}',
    ultimo_uso_mai: 'nessuno l’ha ancora usato',
    posti: 'Posti acquistati',
    posti_valore: '{{usati}} usati su {{acquistati}}',
    posti_senza_limite: 'senza limite',
    abbonamenti: {
      esente: 'Esente',
      in_prova: 'In prova',
      pagante: 'Pagante',
      insoluto: 'Insoluto',
      cancellato: 'Cancellato',
      gratuito: 'Gratuito',
    },
    apri: 'Apri la scheda dell’azienda',
  },
  mappa: {
    sede: '{{azienda}}, sede di {{sede}}',
    luoghi_due: '{{a}} e {{b}}',
    luoghi_altri_one: '{{luogo}} e un altro comune',
    luoghi_altri_other: '{{luogo}} e altri {{count}} comuni',
    descrizione: 'Mappa dell’Italia con le aziende',
    avvicina: 'Avvicina',
    allontana: 'Allontana',
    tutta_italia: 'Torna a tutta l’Italia',
    gruppo: '{{count}} aziende vicine: tocca per avvicinarti',
    segno_adesso: '{{nome}}: {{account}} account, {{adesso}} al lavoro adesso',
    segno: '{{nome}}: {{account}} account, {{attive}} al lavoro',
  },
  pannello: {
    stesso_punto_one: '{{count}} azienda in questo punto',
    stesso_punto_other: '{{count}} aziende nello stesso punto',
    apri: 'Apri il riepilogo',
    riduci: 'Riduci il riepilogo',
  },
  condividi: {
    titolo: 'Condividi la mappa',
    spiegazione: 'Chi riceve il link vede la mappa delle aziende attive: nome, logo, città, livello, account, persone al lavoro e data di iscrizione. Non vede pagamenti, posti acquistati né le aziende spente, e non entra nel gestionale.',
    destinatario: 'Per chi è',
    destinatario_aiuto: 'Serve a te per riconoscere il link nell’elenco. Chi lo apre non lo vede.',
    destinatario_esempio: 'Mario Rossi, banca',
    durata: 'Vale per',
    giorni_one: '{{count}} giorno',
    giorni_other: '{{count}} giorni',
    crea: 'Crea il link',
    creando: 'Creo il link…',
    pronto: 'Il link per {{destinatario}} è pronto: vale fino al {{data}}.',
    copia: 'Copia il link',
    copiato: 'Link copiato',
    copia_non_riuscita: 'La copia non è riuscita: seleziona il link e copialo a mano.',
    altro: 'Crea un altro link',
    attivi: 'I link creati',
    nessun_link: 'Nessun link creato finora.',
    scade_il: 'vale fino al {{data}}',
    scaduto_il: 'scaduto il {{data}}',
    aperto_one: 'aperto {{count}} volta, l’ultima {{quando}}',
    aperto_other: 'aperto {{count}} volte, l’ultima {{quando}}',
    mai_aperto: 'non ancora aperto',
    ritira: 'Ritira',
    ritira_titolo: 'Ritirare il link per {{destinatario}}?',
    ritira_testo: 'Chi ha il link non vedrà più la mappa. Un link ritirato non si riattiva: se serve di nuovo, se ne crea un altro.',
    ritira_conferma: 'Ritira il link',
    ritirato: 'Link per {{destinatario}} ritirato',
    annulla: 'Annulla',
    chiudi: 'Chiudi',
    errore: 'Il link non si è salvato: {{motivo}}',
  },
  condivisa: {
    non_attivo_titolo: 'Questo link non è più attivo',
    non_attivo_testo: 'Chiedi a chi te l’ha mandato un link nuovo.',
  },
} as const;
